import { GetAdvocatesByUserIdMeta, GetAdvocatesByUserIdPayload } from 'types/store/GetAdvocatesByUserId';
import { createAsyncReducer } from 'utils/Redux';

import { getAdvocatesByUserIdActions } from '../actions';

export default createAsyncReducer<GetAdvocatesByUserIdMeta, GetAdvocatesByUserIdPayload>(getAdvocatesByUserIdActions);
